var _defs, _path, _circle, _polygon, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _polygon5, _g, _rect4, _circle2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _polygon6, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _polygon7, _polygon8, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _polygon9, _polygon10, _path4, _path5, _path6, _path7, _path8, _path9, _circle3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyecare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 985,
    height: 692.97,
    viewBox: "0 0 985 692.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "62e9b6da-24f7-4061-9c04-454aab4390a5-375",
    x1: 599.51,
    y1: 796.49,
    x2: 599.51,
    y2: 363.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mindfulness") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.58,149.83c-12.12,1.58-25.29,4.24-33.3,14.83-9.47,12.52-8.2,31.55-3.91,47.4s11.07,31.3,11,47.9c-.19,26.39-18.21,48.79-38.72,60.6s-43.66,15.62-65.8,22.51A256,256,0,0,0,215.08,370c-15.59,9.67-31.27,22.31-37.51,41.39-10.23,31.29,8.59,64.5,27.18,90.19,57,78.77,129.66,154.35,218.48,162C489.58,669.25,556,635.69,621.63,648c30.15,5.64,58.24,20.66,86.54,33.89s58.07,25,88.58,23.5,62.15-18.8,75.37-50.49c7.81-18.73,8.6-40.45,15.82-59.49C910.06,537,979,527.52,1019,483.56c21-23.09,33-54.8,43-86.22,16.15-51.12,28.26-105,25.56-159.35-1.18-23.66-5.6-48.23-18.73-66.49-9.55-13.29-22.88-22.11-35.9-30.64-29.64-19.42-61.46-39.47-95.51-37.16-19.62,1.33-38.18,10.06-56.9,16.9-35.66,13-72.86,19.44-109.87,25.79-61.15,10.5-123.18,21-185.16,15.76-27.37-2.33-53.22-11.63-80.15-15.44C472.59,142.08,437.2,145.58,404.58,149.83Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 791,
    cy: 169.97,
    r: 38,
    fill: "#6c63ff",
    opacity: 0.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "671.33 304.12 323.6 304.12 343.47 242.97 354.12 242.97 356.25 258.83 631.59 258.83 633.01 242.97 645.78 242.97 671.33 304.12",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "671.33 304.12 323.6 304.12 343.47 242.97 354.12 242.97 356.25 258.83 631.59 258.83 633.01 242.97 645.78 242.97 671.33 304.12",
    opacity: 0.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "695.46 317.71 292.38 317.71 282.44 292.8 703.98 292.8 695.46 317.71",
    fill: "#6c63ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "682.69 333.57 302.31 333.57 292.38 317.71 695.46 317.71 682.69 333.57",
    fill: "#6c63ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 302.31,
    y: 329.04,
    width: 380.37,
    height: 18.12,
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 376.6,
    width: 432.89,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 376.6,
    width: 432.89,
    height: 67.95,
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "985 605.35 0 598.56 28.39 437.75 963.71 437.75 985 605.35",
    fill: "#6c63ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279,555.53h12.58a15,15,0,0,1,15,15v30.3a0,0,0,0,1,0,0H264a0,0,0,0,1,0,0v-30.3A15,15,0,0,1,279,555.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.25,555.53h12.58a15,15,0,0,1,15,15v30.3a0,0,0,0,1,0,0H356.25a0,0,0,0,1,0,0v-30.3A15,15,0,0,1,371.25,555.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.21,555.53h12.58a15,15,0,0,1,15,15v30.3a0,0,0,0,1,0,0H471.21a0,0,0,0,1,0,0v-30.3A15,15,0,0,1,486.21,555.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.43,555.53H618a15,15,0,0,1,15,15v30.3a0,0,0,0,1,0,0H590.43a0,0,0,0,1,0,0v-30.3A15,15,0,0,1,605.43,555.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.53,555.53h12.58a15,15,0,0,1,15,15v30.3a0,0,0,0,1,0,0H685.53a0,0,0,0,1,0,0v-30.3A15,15,0,0,1,700.53,555.53Z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 469.79,
    y: 444.55,
    width: 45.42,
    height: 90.6,
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.35,
    cy: 632.53,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 320.76,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 366.18,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 410.18,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 458.44,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 523.72,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 567.72,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 617.4,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 659.98,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 705.4,
    y: 376.6,
    width: 7.1,
    height: 67.95,
    fill: "#6c63ff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "712.49 381.13 279.6 381.13 254.06 358.48 736.62 358.48 712.49 381.13",
    fill: "#6c63ff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 316.51,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 405.92,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 454.18,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 518.05,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 563.47,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 613.14,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 655.72,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 695.46,
    y: 381.13,
    width: 17.03,
    height: 9.06,
    fill: "#6c63ff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "739.46 358.48 252.64 358.48 246.96 342.63 743.72 342.63 739.46 358.48",
    fill: "#6c63ff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "739.46 358.48 252.64 358.48 246.96 342.63 743.72 342.63 739.46 358.48",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.5,
    cy: 335.83,
    rx: 11.35,
    ry: 18.12,
    fill: "#6c63ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.5,
    cy: 335.83,
    rx: 11.35,
    ry: 18.12,
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.5,
    cy: 335.83,
    rx: 7.1,
    ry: 11.32,
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M766.17,700.64l-48.68-37.36s-3.93-15.57-5.5-26.47-3.93-57.6-3.93-57.6a67.86,67.86,0,0,0,2.21-12.36c.48-.1,1-.22,1.45-.35a24.28,24.28,0,0,0,16.39-14.13c5-12.44-1.46-27.14-9.64-37s-18.47-17.78-23.85-30c-6.64-15.06-4.37-33.26-7.76-49.74a15,15,0,0,0-2.51-6.43c-2.1-2.61-5.39-3.18-8.33-4.22-9.28-3.29-16.24-12.31-21.67-21.72-8.79-15.25-17.89-38.44-36-39.76-6.73-.49-13.76,1.78-20.56,1.76-10.55,0-21,.13-31.46,1.58-3.74.51-7.62,1.21-10.74,3.68-10.71,8.47-5.86,30.86-16.18,40-3.07,2.71-7,3.68-10.47,5.54-13.08,7-18.89,25.67-18.12,42.47.36,7.87,2,16.07,6.65,21.82,3.68,4.6,8.93,7.24,12.36,12.09,5.54,7.83,4.79,18.21,4.19,28.77-7.4,3.1-13.34,6.66-15.21,10.49-6.28,12.84-5.5,56.82-5.5,56.82s2.36,72-15.7,81l-67.53,46.7s-47.9-41.64-59.68-17.12c-8.06,16.77,21.35,26.26,40.74,30.58-12.23,8.68-19,24.72-13.26,35.59,9,17.12,34.16,28.8,34.16,28.8s95.95,4.63,140.3-5.31h.73c18.83,3.41,45.85,7,67.52,4.84.41,1,.7,1.64.7,1.64s139,11.68,164.11-35.81c12.89-24.35-.56-35.6-16.72-40.78,18.09-1.44,38.69-6.5,41.06-21.88C834.09,668.73,766.17,700.64,766.17,700.64Zm-14,14.89c-25.43,9.27-46.08,9.79-57.07,9.09-5.41-11.77-27.92-62.79-28.51-96.93.14-7.62,1.5-14.28,4.54-19.28,6.55-10.77,8.48-19.21,8.26-25.63,0-.48,0-.94,0-1.4a26.07,26.07,0,0,0-.57-5.84,15.32,15.32,0,0,1,.93,8.34c-2.36,12.07,3.93,90.29,3.93,90.29s5.1,17.51,15.7,22.57ZM503.12,710l24.34-15.57S538.85,689,540,675.73l8-63.23a65.12,65.12,0,0,0,2.16,8c1.42,4.15,2,10.23,2.11,17.47C552,673.22,540,731.78,540,731.78l.15,0-.09.42-.85.05c-19.75-.6-65.77-2.32-91.54-5.89Zm-42.65,36.86V747h-6Z",
    transform: "translate(-107.5 -103.51)",
    fill: "url(#62e9b6da-24f7-4061-9c04-454aab4390a5-375)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M652.52,409.62c5.25,9.18,12,18,20.95,21.18,2.84,1,6,1.57,8,4.11a14.74,14.74,0,0,1,2.42,6.27c3.27,16.07,1.08,33.82,7.5,48.5,5.2,11.89,15.15,19.64,23.06,29.23s14.12,23.93,9.32,36.05A23.53,23.53,0,0,1,708,568.74c-6.62,1.79-13.53,1-20.25-.15-8.86-1.57-17.88-4-25.26-10-12.77-10.37-18.17-29-24.85-45.56-3.14-7.76-7.31-15.89-14.21-18.67-7.91-3.18-16.79,2.13-21.92,9.92s-7.41,17.58-9.89,27c-2.8,10.63-6.35,21.68-13.71,28.63a23.08,23.08,0,0,1-24.64,4.93c-8.2-3.42-14.69-12.06-16.57-22.09-2.91-15.46,4.06-34-4.49-46.22-3.32-4.73-8.39-7.31-12-11.79-4.45-5.61-6.08-13.6-6.43-21.27-.75-16.38,4.87-34.63,17.51-41.41,3.38-1.81,7.15-2.76,10.12-5.4,10-8.88,5.29-30.71,15.64-39,3-2.41,6.76-3.08,10.38-3.59,10.14-1.41,20.21-1.57,30.41-1.54,6.58,0,13.37-2.19,19.88-1.71C635.23,372.14,644,394.75,652.52,409.62Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#965d7b"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.29 637.16 361.12 682.53 629 680.94 623.9 631.41 533.33 620.87 374.51 630.45 357.29 637.16",
    fill: "#575988"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.29 637.16 361.12 682.53 629 680.94 623.9 631.41 533.33 620.87 374.51 630.45 357.29 637.16",
    opacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M641.06,772.39l-89.18,8.35s61.1,15.56,96.77,8Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#f7c4a7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M641.06,772.39l-89.18,8.35s61.1,15.56,96.77,8Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M573.13,452.86s17.46,45.92-8.35,66.41-4.55,77.8-4.55,77.8l99.43-4.55s9.87-64.51,4.55-78.18c0,0-23.53,6.83-28.84-7.59s-9.11-53.89-9.11-53.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#f7c4a7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M550.36,730.64s-83.87-1.9-108.53-8-45.92,23.15-37.19,39.85,33,28.08,33,28.08,124.85,6.07,151.8-11c0,0,10.25-29.22,0-34.91H459.29l96-1.9Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#575988"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M683.57,721.92s28.08,6.07,66.79-9.11c0,0,72.48-2.28,48.2,44s-158.63,34.91-158.63,34.91-8-17.08,0-21.63,77.42-33.77,99-32.26l-60,11.76Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#575988"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M629.7,474.95c-1.45-10.81-2.3-19.62-2.3-19.62H574.27a103.6,103.6,0,0,1,5.08,21.48,41.75,41.75,0,0,0,50.35-1.86Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.66,
    cy: 336.63,
    r: 41.74,
    fill: "#f7c4a7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M577.69,512.82s-50.09,9.49-56.16,22-5.31,55.41-5.31,55.41,2.28,70.21-15.18,78.93l-65.27,45.54s-46.3-40.61-57.68-16.7,54.65,32.64,54.65,32.64l73.62-22,23.53-15.18s11-5.31,12.14-18.22l9.87-78.18,39.47-11.38H655.1l8.54-24.38s15.75,12.62,13.47,24.38,3.79,88,3.79,88,4.93,17.08,15.18,22L755.29,717s62.62,6.07,66.79-21.25-61.48,3.79-61.48,3.79l-47.06-36.43s-3.79-15.18-5.31-25.81-3.79-56.16-3.79-56.16,14.42-47.82-27.32-56.16l-53.89-16.7Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#f7c4a7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M544.1,522.49l7.78,51.42s-8,23.91,0,47.44S542,732.54,542,732.54s93.73,30,151-4.55c0,0-42.12-88.8-24.29-118.4s.29-41.18.29-41.18L671.8,514l-12.9-3.79L651.31,564s-52.37,36.43-91.08,4.55l-8.35-58.44Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M598.24,583.61a30.73,30.73,0,0,0-39.79-11.19C571.16,581.93,585.17,584.47,598.24,583.61Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fff",
    opacity: 0.07
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M619.75,577.91a30.73,30.73,0,0,1,39.79-11.19C646.84,576.23,632.82,578.78,619.75,577.91Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fff",
    opacity: 0.07
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M544.1,522.49l7.78,48.76s-8,23.91,0,47.44S542,729.88,542,729.88s93.73,30,151-4.55c0,0-42.12-88.8-24.29-118.4s.29-41.18.29-41.18l2.74-54.45-12.9-3.79-7.59,53.89s-52.37,36.43-91.08,4.55l-8.35-58.44Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M543.72,522.11l8.16,49.9s-8,23.91,0,47.44S542,730.64,542,730.64s93.73,30,151-4.55c0,0-42.12-88.8-24.29-118.4s.29-41.18.29-41.18l2.74-54.45-12.9-3.79-7.59,53.89s-52.37,36.43-91.08,4.55l-8.35-58.44Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M582.24,749.24,602,746.58s22.77-29.22,39.09-6.83c0,0,6.83,14.42,15.18,17.08a112.22,112.22,0,0,0,17.46,3.79l-33.77,9.49s-14.8,8.73-30.36,6.45a59,59,0,0,0-27.32,2.28Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#f7c4a7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M560.42,625.33s35.67,5.31,41.74-4.17",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M628,619.26s6.83,6.83,34.15,1.9",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M558.52,513.38s26.18,3.79,31.12,1.52",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M616.21,513.38s26.18,3.79,31.12,1.52",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M585.09,746.39s7.21,34,0,35.2-17.46-5.6-17.46-6.36,4.55-22.39,4.55-22.39Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M584.33,746.39s7.21,34,0,35.2-17.46-5.6-17.46-6.36,4.55-22.39,4.55-22.39Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#575988"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M549.1,508.41c-3.18,7.39-4.31,16.11-.93,23.41,2.58,5.57,7.62,10.08,8.59,16.14,1.22,7.6-4.41,15.33-2.31,22.73.8,2.84,2.67,5.24,4.57,7.49,5.78,6.83,13.46,13.44,22.38,12.91,1.41-13.78-10.5-27.15-6.6-40.44,1.4-4.76,4.68-8.72,6.66-13.26,3.29-7.53,2.82-16.13,1.63-24.26-1.73-11.79-6.11-26.26-17.8-31.78-5.38-2.54-13-2.72-14.92,4.17-1,3.68,1.4,7.14,1.73,10.74C552.52,500.83,550.87,504.3,549.1,508.41Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M549.1,507.27c-3.18,7.39-4.31,16.11-.93,23.41,2.58,5.57,7.62,10.08,8.59,16.14,1.22,7.6-4.41,15.33-2.31,22.73.8,2.84,2.67,5.24,4.57,7.49,5.78,6.83,13.46,13.44,22.38,12.91,1.41-13.78-10.5-27.15-6.6-40.44,1.4-4.76,4.68-8.72,6.66-13.26,3.29-7.53,2.82-16.13,1.63-24.26-1.73-11.79-6.11-26.26-17.8-31.78-5.38-2.54-13-2.72-14.92,4.17-1,3.68,1.4,7.14,1.73,10.74C552.52,499.7,550.87,503.17,549.1,507.27Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#965d7b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M552.07,419.65s55.41-7.59,56.92,3.79,50.47,30,50.47,30l-12.14-30-22.39-37.19s-41-3-42.88,0-23.53,12.9-23.53,12.9Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M552.07,418.89s55.41-7.59,56.92,3.79,50.47,30,50.47,30l-12.14-30L624.93,385.5s-41-3-42.88,0-23.53,12.9-23.53,12.9Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#965d7b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M648.49,500a27,27,0,0,1,5.56,11.13c.92,3.91.95,8,1.83,11.92,1.87,8.35,7.39,15.37,13.16,21.69a23.67,23.67,0,0,0,6.72,5.66c2.64,1.3,6,1.57,8.45,0-2.32-1.9-3.58-4.81-4.41-7.7a39.58,39.58,0,0,1-1.54-12.41c.25-7,2.3-14.39-.61-20.77-1.68-3.68-4.81-6.48-8-9a42.61,42.61,0,0,0-7.14-4.7c-4.71-2.35-10.12-3.38-15.32-3.89C640.41,491.23,646.34,497.42,648.49,500Z",
    transform: "translate(-107.5 -103.51)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M648.49,498.85A27,27,0,0,1,654.05,510c.92,3.91.95,8,1.83,11.92,1.87,8.35,7.39,15.37,13.16,21.69a23.67,23.67,0,0,0,6.72,5.66c2.64,1.3,6,1.57,8.45,0-2.32-1.9-3.58-4.81-4.41-7.7a39.58,39.58,0,0,1-1.54-12.41c.25-7,2.3-14.39-.61-20.77-1.68-3.68-4.81-6.48-8-9a42.61,42.61,0,0,0-7.14-4.7c-4.71-2.35-10.12-3.38-15.32-3.89C640.41,490.09,646.34,496.28,648.49,498.85Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#965d7b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M623.68,268.92H616.8a4.82,4.82,0,1,0,0-9.63H561.07a4.82,4.82,0,0,0,0,9.63h6.88a4.82,4.82,0,1,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63h55.73a4.82,4.82,0,1,0,0-9.63h9.63a4.82,4.82,0,1,0,0-9.63Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#252223",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M893.68,268.92H886.8a4.82,4.82,0,1,0,0-9.63H831.07a4.82,4.82,0,0,0,0,9.63h6.88a4.82,4.82,0,1,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63h55.73a4.82,4.82,0,1,0,0-9.63h9.63a4.82,4.82,0,1,0,0-9.63Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#252223",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M318.68,391.92H311.8a4.82,4.82,0,1,0,0-9.63H256.07a4.82,4.82,0,0,0,0,9.63h6.88a4.82,4.82,0,0,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63h55.73a4.82,4.82,0,1,0,0-9.63h9.63a4.82,4.82,0,0,0,0-9.63Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#252223",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M896.23,778.63s-24.67-83.76,4.63-145.41c12.3-25.87,16.38-54.92,10.7-83a222.5,222.5,0,0,0-11.75-39",
    transform: "translate(-107.5 -103.51)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M918,472.31c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M948.76,529.17c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,0,1,31.2,20.2Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M947.41,626.34c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,1,1,16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M929.84,699.63c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,1,1,22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M872.37,554.66c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23a18.59,18.59,0,0,0-25.9,26.66Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M852.91,640.63c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,1,0-16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M845.46,726.79c8.25,6.1,43.24,8.86,43.24,8.86S875.82,703,867.56,696.9a18.59,18.59,0,1,0-22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M918,472.31c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M948.76,529.17c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,0,1,31.2,20.2Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M947.41,626.34c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,1,1,16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M929.84,699.63c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,1,1,22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M872.37,554.66c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23a18.59,18.59,0,0,0-25.9,26.66Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M852.91,640.63c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,1,0-16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M845.46,726.79c8.25,6.1,43.24,8.86,43.24,8.86S875.82,703,867.56,696.9a18.59,18.59,0,1,0-22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M314.23,776.63s-24.67-83.76,4.63-145.41c12.3-25.87,16.38-54.92,10.7-83a222.5,222.5,0,0,0-11.75-39",
    transform: "translate(-107.5 -103.51)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M336,470.31c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M366.76,527.17c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,0,1,31.2,20.2Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M365.41,624.34c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M347.84,697.63c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,1,1,22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M290.37,552.66c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23a18.59,18.59,0,0,0-25.9,26.66Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M270.91,638.63c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,0,0-16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M263.46,724.79c8.25,6.1,43.24,8.86,43.24,8.86S293.82,701,285.56,694.9a18.59,18.59,0,1,0-22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#6c63ff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M336,470.31c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M366.76,527.17c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,0,1,31.2,20.2Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M365.41,624.34c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M347.84,697.63c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,1,1,22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M290.37,552.66c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23a18.59,18.59,0,0,0-25.9,26.66Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M270.91,638.63c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,0,0-16.74,33.19Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M263.46,724.79c8.25,6.1,43.24,8.86,43.24,8.86S293.82,701,285.56,694.9a18.59,18.59,0,1,0-22.11,29.89Z",
    transform: "translate(-107.5 -103.51)",
    fill: "#fc6681"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyecare);
export default __webpack_public_path__ + "static/media/eyecare.b3e4fe8a30107aaad0764d0dce008c19.svg";
export { ForwardRef as ReactComponent };